
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bounty",
      function () {
        return require("private-next-pages/bounty.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bounty"])
      });
    }
  